import { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import * as styled from './styles';

export const AnimatedText = function AnimatedText(props) {
  const { texts } = props;

  const [index, setIndex] = useState(0);
  const indexRef = useRef(index);
  const timeoutId = useRef(null);
  indexRef.current = index;

  useEffect(() => {
    const increaseIndex = () => {
      if (indexRef.current < texts.length - 2) {
        timeoutId.current = setTimeout(increaseIndex, 3000);
      }
      setIndex((currentIndex) => currentIndex + 1);
    };

    timeoutId.current = setTimeout(increaseIndex, 3000);

    return () => {
      clearTimeout(timeoutId.current);
    };
  }, [texts.length]);

  return (
    <styled.Wrapper>
      <styled.List index={index}>
        {texts.map((t) => (
          <styled.Text key={t}>{t}</styled.Text>
        ))}
      </styled.List>
    </styled.Wrapper>
  );
};

AnimatedText.propTypes = {
  texts: PropTypes.arrayOf(PropTypes.string),
};
